"use client";

import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { useBlock } from "timvir/core";
import { useResizeObserver, useResizeObserverEntry } from "timvir/hooks";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
import { Caption, Handle, Ruler } from "./internal";
/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
export function Viewport(props) {
  const $ = _c(77);
  const block = useBlock(props);
  let className;
  let code;
  let rest;
  let src;
  if ($[0] !== block.props) {
    ({
      src,
      code,
      className,
      ...rest
    } = block.props);
    $[0] = block.props;
    $[1] = className;
    $[2] = code;
    $[3] = rest;
    $[4] = src;
  } else {
    className = $[1];
    code = $[2];
    rest = $[3];
    src = $[4];
  }
  let t0;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      settled: false
    };
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const [state, setState] = React.useState(t0);
  const [svgRef, svgROE] = useResizeObserverEntry();
  const [height, setHeight] = React.useState(undefined);
  const [maxHeight, setMaxHeight] = React.useState(undefined);
  const [width, setWidth] = React.useState(undefined);
  let t1;
  let t2;
  if ($[6] !== svgROE || $[7] !== width) {
    t1 = () => {
      if (width === undefined && svgROE) {
        setWidth(svgROE.contentRect.width);
      } else {
        if (svgROE) {
          const max = svgROE.contentRect.width - 144;
          if (width !== undefined && width > max) {
            setWidth(max);
          }
        }
      }
    };
    t2 = [svgROE, width];
    $[6] = svgROE;
    $[7] = width;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  React.useEffect(t1, t2);
  const lock = React.useRef("");
  const iframeRef = React.useRef(null);
  let t3;
  let t4;
  if ($[10] !== svgROE) {
    t3 = () => {
      const onMouseMove = ev => {
        if (lock.current && svgROE) {
          ev.preventDefault();
          const max_0 = svgROE.contentRect.width - 144;
          setWidth(width_0 => Math.min(max_0, Math.max(320, (width_0 ?? 0) + 2 * ev.movementX * ({
            left: -1,
            right: 1
          }[lock.current] ?? 1))));
        }
      };
      const onMouseUp = () => {
        lock.current = "";
        const iframeElement = iframeRef.current;
        if (iframeElement) {
          iframeElement.style.userSelect = "";
          iframeElement.style.pointerEvents = "";
        }
        setHeight(height_0 => {
          setMaxHeight(height_0);
          return height_0;
        });
      };
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
      return () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
      };
    };
    t4 = [svgROE];
    $[10] = svgROE;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[13] !== maxHeight) {
    t5 = entries => {
      const height_1 = entries[entries.length - 1].contentRect.height;
      setHeight(height_1);
      setMaxHeight(Math.max(height_1, maxHeight ?? 0));
    };
    $[13] = maxHeight;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const iframeRO = useResizeObserver(t5);
  let T0;
  let rootStyleProps;
  let t6;
  let t7;
  let t8;
  if ($[15] !== className || $[16] !== rest || $[17] !== state.settled) {
    rootStyleProps = stylex.props(layoutStyles.block, layoutStyles.fullWidth, styles.root);
    T0 = Root;
    t6 = true;
    t7 = rest;
    t8 = cx(!state.settled && "timvir-unsettled", className, rootStyleProps.className);
    $[15] = className;
    $[16] = rest;
    $[17] = state.settled;
    $[18] = T0;
    $[19] = rootStyleProps;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    T0 = $[18];
    rootStyleProps = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
  }
  let t9;
  if ($[23] !== rest.style || $[24] !== rootStyleProps.style) {
    t9 = {
      ...rootStyleProps.style,
      ...rest.style
    };
    $[23] = rest.style;
    $[24] = rootStyleProps.style;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = svgROE?.contentRect.width;
  let t11;
  if ($[26] !== t10 || $[27] !== width) {
    t11 = <Ruler containerWidth={t10} viewportWidth={width} />;
    $[26] = t10;
    $[27] = width;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== width) {
    t12 = <div className="x10l6tqk xwa60dl x1nrll8i x11lhmoz xss6m8b">{width}px</div>;
    $[29] = width;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== svgRef || $[32] !== t11 || $[33] !== t12) {
    t13 = <div ref={svgRef} className="x1n2onr6">{t11}{t12}</div>;
    $[31] = svgRef;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      0: {
        className: "xizzuc2 x6zybfr x1n2onr6 x98rzlu xpyat2d x1h3vnj2 x10r4kp7 xb3r6kr"
      },
      1: {
        className: "xizzuc2 x6zybfr x1n2onr6 x98rzlu xpyat2d x10r4kp7 xb3r6kr x1c74tu6 x10e4vud xa4qsjk x9vmsy x1esw782 xdftl3q x9emw9s x1w911z x1nj7uno"
      }
    };
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const t15 = t14[!!(height === undefined) << 0];
  let t16;
  if ($[36] !== height || $[37] !== width) {
    t16 = {
      width,
      height
    };
    $[36] = height;
    $[37] = width;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== iframeRO) {
    t17 = ev_0 => {
      const document = ev_0.currentTarget.contentDocument;
      if (!document) {
        console.warn("Viewport: iframe has no contentDocument");
        return;
      }
      const initializeDocument = () => {
        if (document.readyState === "complete") {
          const style = document.createElement("style");
          style.id = "timvir-viewport-style";
          style.innerHTML = "body { margin: 0 }";
          document.head.appendChild(style);
          const {
            height: height_2
          } = document.body.getBoundingClientRect();
          setHeight(height_2);
          setMaxHeight(height_2);
          iframeRO.observe(document.body);
          setTimeout(() => {
            setState({
              settled: true
            });
          }, 50);
        } else {
          document?.addEventListener("readystatechange", initializeDocument, {
            once: true
          });
        }
      };
      initializeDocument();
    };
    $[39] = iframeRO;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const t18 = height === undefined ? 0 : 1;
  const t19 = height === undefined ? "none" : undefined;
  let t20;
  if ($[41] !== t18 || $[42] !== t19) {
    t20 = {
      opacity: t18,
      pointerEvents: t19
    };
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== src || $[45] !== t17 || $[46] !== t20) {
    t21 = <iframe ref={iframeRef} frameBorder="0" src={src} onLoad={t17} className="x1lliihq x10l6tqk x13vifvy xu96u03 xh8yej3 x5yr21d x1pl5831" style={t20} />;
    $[44] = src;
    $[45] = t17;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t15 || $[49] !== t16 || $[50] !== t21) {
    t22 = <div {...t15} style={t16}>{t21}</div>;
    $[48] = t15;
    $[49] = t16;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Handle gridColumn="1" lock={lock} edge="left" iframeRef={iframeRef} />;
    t24 = <Handle gridColumn="3" lock={lock} edge="right" iframeRef={iframeRef} />;
    $[52] = t23;
    $[53] = t24;
  } else {
    t23 = $[52];
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t22) {
    t25 = <div className="x78zum5 x1qjc9v5 xl56j7k"><div><div className="x18zih8k xrvj5dj x7tmw4v xyy29n5 xjv0b96">{t22}{t23}{t24}</div></div></div>;
    $[54] = t22;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  const t26 = svgROE?.contentRect.width;
  let t27;
  if ($[56] !== t26 || $[57] !== width) {
    t27 = <Ruler containerWidth={t26} viewportWidth={width} />;
    $[56] = t26;
    $[57] = width;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== T0 || $[60] !== t13 || $[61] !== t25 || $[62] !== t27 || $[63] !== t6 || $[64] !== t7 || $[65] !== t8 || $[66] !== t9) {
    t28 = <T0 data-timvir-b-viewport={t6} {...t7} className={t8} style={t9}>{t13}{t25}{t27}</T0>;
    $[59] = T0;
    $[60] = t13;
    $[61] = t25;
    $[62] = t27;
    $[63] = t6;
    $[64] = t7;
    $[65] = t8;
    $[66] = t9;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== code || $[69] !== src) {
    t29 = <Caption src={src} code={code} />;
    $[68] = code;
    $[69] = src;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  const t30 = (maxHeight ?? 0) - (height ?? 0);
  let t31;
  if ($[71] !== t30) {
    t31 = <div style={{
      gridColumn: "1 / -1",
      height: t30,
      transition: "height 0.16s"
    }} />;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t28 || $[74] !== t29 || $[75] !== t31) {
    t32 = <>{t28}{t29}{t31}</>;
    $[73] = t28;
    $[74] = t29;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  return t32;
}
const styles = {
  root: {
    ktR8K2: "x1vjgj0v",
    k1K539: "xat24cr",
    $$css: true
  }
};